/** Photo slide variant — Ken Burns background + warm colour grade +
 *  late-fade caption. */
import { resolveAssetUrl } from '@/lib/assetUrl';
import type { VariantProps } from '../registry';

export function PhotoVariant({ slide }: VariantProps) {
  const imageUrl = slide.imageUrl ? resolveAssetUrl(slide.imageUrl) : '';
  return (
    <>
      {imageUrl ? (
        <>
          <div
            className="preview-entry-ken-burns absolute inset-0 bg-cover bg-center z-[1] brightness-90 saturate-[1.1]"
            style={{ backgroundImage: `url("${imageUrl}")` }}
          />
          <div className="preview-slide-photo-grade" aria-hidden />
        </>
      ) : (
        <div className="preview-slide-photo flex items-center justify-center bg-zinc-800 text-zinc-500">
          <span className="text-sm">No image set</span>
        </div>
      )}
      {slide.contentText && (
        <div className="preview-slide-photo-overlay">
          <p className="preview-slide-photo-caption">{slide.contentText}</p>
        </div>
      )}
    </>
  );
}
